import React, { useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Breadcrumb } from '@fikasio/react-ui-components';
import ReactGA from 'react-ga4';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import TaskPane from 'components/tasks/TaskPane';
import BasePage from 'components/UI/BasePage';
import { useGetTaskQuery } from 'services/tasks/api';
import links from 'utils/links';
import { spaLinkProps } from 'utils/spaLink';

const TaskPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { slug } = useParams<{ slug: string; }>();
  const { data: task } = useGetTaskQuery(slug!, { skip: !slug });

  useEffect(() => {
    ReactGA.send({
      hitType: 'pageview',
      page: location.pathname,
    });
  }, [location.pathname]);

  return (
    <>
      <Helmet>
        <title>{`${t('tasks')}${task?.description ? ` - ${task.description}` : ''}`}</title>
      </Helmet>
      <BasePage>
        <Breadcrumb
          items={[
            { ...spaLinkProps(links.paths.home, navigate), label: t('home') },
            { ...spaLinkProps(links.paths.tasks, navigate), label: t('tasks') },
            { label: task?.description ?? '' },
          ]}
        />
        {
          slug && (
            <TaskPane
              id={slug}
              showExpandIcon={false}
            />
          )
        }
      </BasePage>
    </>
  );
};

export default TaskPage;
